import {
  ByCodeflexText,
  Close,
  Container,
  DownWrapper,
  Wrapper,
} from './SideMenu.styled';
import { Dispatch, forwardRef, SetStateAction } from 'react';
import { AppMode } from 'store/Common/reducers/common';
import { useSelector } from 'react-redux';
import { IRootReducerState } from 'store/store';
import { useTranslation } from 'react-i18next';
import { NavigationLabel } from '../Header.styled';
import { useNavigateWithQuery } from 'utils/hooks/useNavigateWithQuery';
import { RoutesConfig } from 'navigation/routes';
import { ReactComponent as CodeflexLogo } from 'assets/icons/codeflexLogoTextRight.svg';
import Icon from 'components/Icon/Icon';
import { COLORS } from 'assets/styled';
import { X } from '@phosphor-icons/react';

interface ISideMenuProps {
  active: boolean;
  setSideMenuIsOpen: Dispatch<SetStateAction<boolean>>;
  ref: any;
}

const SideMenu = forwardRef<HTMLDivElement, ISideMenuProps>(
  ({ active, setSideMenuIsOpen }, ref) => {
    const { t } = useTranslation();
    const appMode: AppMode = useSelector(
      (state: IRootReducerState) => state.commonInfo.appMode
    );
    const navigateWithQuery = useNavigateWithQuery();

    const closeSideMenu = () => {
      setSideMenuIsOpen(false);
    };

    return (
      <Container active={active} ref={ref}>
        <Close onClick={closeSideMenu}>
          <Icon svg={X} color={COLORS.GREEN} />
        </Close>

        <Wrapper>
          {appMode === AppMode.SUPPLIER ? (
            <NavigationLabel
              onClick={() => {
                navigateWithQuery(RoutesConfig.SupplierOrders.fullPath);
                setSideMenuIsOpen(false);
              }}
              isSelected={location.pathname.includes(
                RoutesConfig.SupplierOrders.fullPath
              )}
            >
              {t('Orders')}
            </NavigationLabel>
          ) : null}

          {appMode === AppMode.BUYER ? (
            <NavigationLabel
              onClick={() => {
                navigateWithQuery(RoutesConfig.BuyerOrders.fullPath);
                setSideMenuIsOpen(false);
              }}
              isSelected={location.pathname.includes(
                RoutesConfig.BuyerOrders.fullPath
              )}
            >
              {t('Orders')}
            </NavigationLabel>
          ) : null}

          {appMode === AppMode.DEALER_PANEL && (
            <>
              <NavigationLabel
                onClick={() => {
                  navigateWithQuery(RoutesConfig.Suppliers.fullPath);
                }}
                isSelected={location.pathname.includes(
                  RoutesConfig.Suppliers.fullPath
                )}
              >
                {t('Suppliers')}
              </NavigationLabel>
              <NavigationLabel
                onClick={() => {
                  navigateWithQuery(RoutesConfig.CustomModels.fullPath);
                }}
                isSelected={location.pathname.includes(
                  RoutesConfig.CustomModels.fullPath
                )}
              >
                {t('Model Editor')}
              </NavigationLabel>
            </>
          )}
        </Wrapper>
        <DownWrapper>
          <ByCodeflexText>{t('Powered by')}:</ByCodeflexText>
          <Icon svg={CodeflexLogo} size={100} fill={COLORS.BLACK} />
        </DownWrapper>
      </Container>
    );
  }
);

SideMenu.displayName = 'SideMenu';

export default SideMenu;
